<template>
  <section id="project">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2 class="section-heading text-uppercase">Project</h2>
          (個人制作)
          <hr />
        </div>
      </div>

      <b-row>
        <b-col
          sm="6"
          lg="4"
          xl="3"
          v-for="(value, key, index) in data.projects"
          :key="index"
        >
          <div
            @click="openModal(value)"
            v-b-modal.modal-center
            type="button"
            class="card project-item btn-outline-secondary"
          >
            <img
              v-bind:src="value.summary.thumb"
              v-bind:alt="value.title"
              class="card-img-top"
            />
            <div class="card-body">
              <h5 class="card-title">{{ value.title }}</h5>
              <p class="card-text">{{ value.summary.text }}</p>
              <!-- <a href="/#/detail" id="more-btn" class="btn btn-secondary float-right">more</a> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <Modal :value="postItem" />
  </section>
</template>

<script>
import data from '../assets/project/projectData.json';
import Modal from './projectDetaliModal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      showContent: false,
      postItem: '',
      data: data,
    };
  },
  methods: {
    openModal(item) {
      // いったんモーダルはなしで
      // this.showContent = true;
      // this.postItem = item;

      // いったんそっこー飛ばさせる
      if (item.links) {
        const url = item.links[0].href;
        window.location.href = url;
      }
    },
    closeModal() {
      this.showContent = false;
    },
  },
};
</script>

<style>
.project-item {
  margin: 15px;
}

#more-btn {
  color: aliceblue;
}
</style>
